import React from 'react';
import { Box, Text, Button, Line, variables, Icons, space } from '@generationtux/component-library';
import { selectItem, deselectItem, getProductImageUrl, getCatalogNumber, scrollTop } from '../../../utils/utils';
import styled from 'styled-components';

const ButtonDeselect = styled(Button)`
  background-color: ${props => variables(props).primary};
  padding: ${space[2]}px;
  border: none;
  position: absolute;
  top: 0;
  right: 0;
  transition: opacity .2s ease;
  ${props => props.visible ?
    `
      opacity: 1;
      pointer-events: auto;
    `
    :
    `
      opacity: 0;
      pointer-events: none;
    `
  }
  @media (hover: hover) {
    &:hover {
      background-color: ${props => variables(props).danger};
    }
  }
`;

const SeeMoreButton = styled(Button)`
  position: absolute;
  bottom: 0;
  right: 0;

  p {
    font-size: ${space[2]}px;
  }
`;

const StyledBox = styled(Box)`
  overflow: hidden;
  position: relative;
  z-index: 1;
  transition: all 0.15s ease;
  transform-origin: center center;
  @media not all and (hover:hover) {
    :active{
      transform: scale(.95);
    }
  }
  img {
    transition: transform .15s ease;
    will-change: transform;
    transform: ${props => props.selected ? 'scale(.97)' : 'scale(1)'};
  }
  ${props =>
    !props.selected &&
    `
    cursor: pointer;
    @media(hover:hover){
      &:hover {
        ${`box-shadow: 0 0 0 1px ${variables(props).primary}, ${variables(props).shadows[3]};`}
        z-index: 20;
      }
    }
  `}
`;

const CollectionGalleryItem = ({
  selectedCatalogNumbers,
  setSelectedCatalogNumbers,
  activeCollection,
  setActiveCollection,
  setProductDetails,
  product,
  isBundle,
  selected,
  modelToggle,
  docBrownsTimeMachine,
  initialItem,
  setActiveItemChanged,
}) => {
  const makeJacketMediaArray = product => {
    return [
      {
        url: getProductImageUrl(product, '_full'),
        label: getCatalogNumber(product),
      },
    ];
  };
  const media =
    isBundle && !modelToggle ? makeJacketMediaArray(product) : product.media.filter(x => x.label === 'PDP_Hero');

  return (
    <StyledBox
      selected={selected}
      display="flex"
      justifyContent="space-between"
      flexFlow="column"
      backgroundColor={selected ? 'primary' : 'white'}
      onTouchStart={(()=>{})}
    >
      <Box>
        <Box style={{ position: 'relative' }}>
          {media.map(x => (
            <img
              key={x.url}
              catalognumber={isBundle ? product.products[0].catalogNumber : product.catalogNumber}
              style={{ display: 'block',width:'100%' }}
              alt="#"
              src={`${x.url}?auto=format&fit=crop&fm=jpg&q=75&w=300${
                product.type === 'suit' || product.type === 'tuxedo' ? '&ar=5:7' : ''
              }`}
              onClick={() => {
                setActiveItemChanged(true);
                docBrownsTimeMachine(
                  selectItem(selectedCatalogNumbers, activeCollection, product, isBundle),
                  true,
                  null
                );
              }}
            />
          ))}

          <SeeMoreButton
            mb={2}
            mr={2}
            buttonType="default"
            size="xs"
            onClick={() => {
              scrollTop();
              docBrownsTimeMachine(
                selectItem(selectedCatalogNumbers, activeCollection, product, isBundle),
                true,
                null
              );
              setProductDetails({ product, isBundle });
            }}
            title="See more details"
          >
            <Box display="flex">
              <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="1.5" width="11" height="7" stroke="black" />
                <rect x="2" width="2" height="1" fill="black" />
                <circle cx="6" cy="5" r="1.5" stroke="black" />
              </svg>

              <Text ml={1}>{product.media.filter(x => x.label.includes('PDP')).length}</Text>
            </Box>
          </SeeMoreButton>
          
          <ButtonDeselect
            buttonType="default"
            size="xs"
            visible={selected}
            onClick={() => {
              docBrownsTimeMachine(deselectItem(selectedCatalogNumbers, activeCollection), true, null);
            }}
            title="See more details"
          >
            <Icons.X />
          </ButtonDeselect>

        </Box>
        {!selected && <Line lineColor="grayLighter" />}
        <Box display="flex" px={2} py={2} backgroundColor={selected ? 'primary' : 'white'}>
          <Text
            onClick={() => {
              docBrownsTimeMachine(selectItem(selectedCatalogNumbers, activeCollection, product, isBundle), true, null);
            }}
            size="xs"
            textColor={selected ? 'black' : 'grayDarker'}
          >
            {isBundle ? product.displayName : product.catalogName}
            <br />${product.cost || product.costToCustomer}
          </Text>
        </Box>
      </Box>
    </StyledBox>
  );
};

export default CollectionGalleryItem;
